import { FC } from 'react';
import { SelfServiceAPI } from 'types';
import { getDiscountVoucherAmount, getPendingScheduledPayment } from 'lib/bookingInfo';
import ChargesSummaryComponent, { ChargesSummaryProps } from 'components/ChargesSummary';
import DownloadInvoiceButton from './DownloadInvoiceButton';

const ChargeSummary: FC<{ booking: SelfServiceAPI.Booking }> = ({ booking }) => {
  const props: ChargesSummaryProps = {
    isCancelled: booking.flags.isCancelled,
    nights: booking.nights,
    baseAmount: booking.payableAtBooking,
    discountAmount: getDiscountVoucherAmount(booking),
    offerTotalAmounts: booking.payableTotals,
    formattedCheckIn: booking.reservation.formattedCheckIn,
    payableAtPropertyTotal: booking.payableAtProperty ? booking.payableAtProperty.total : undefined,
    payableAtPropertyBreakdown: booking.payableAtProperty
      ? booking.payableAtProperty.breakdown.map((item) => ({
          description: item.description,
          charge: item.charge,
        }))
      : undefined,
    paidToDateAmounts: booking.paidBeforeCancellation.totals,
    pendingScheduledPayment: getPendingScheduledPayment(booking),
    ActionComponent: <DownloadInvoiceButton booking={booking} />,
  };

  return <ChargesSummaryComponent {...props} />;
};

export default ChargeSummary;
